import { HttpRequest } from '@angular/common/http';
import { ApiResponse } from 'app/app.types';
import { MOCK_ROUTE_REGISTRY } from './fixtures';
import { shouldMockRequest } from './mock-api.util';
import { isUiOnlyPhase } from './mock-api.config';
import { mockSuccess } from './fixtures/shared';

function genericWriteSuccess(req: HttpRequest<unknown>): ApiResponse<unknown> {
    const body = (req.body && typeof req.body === 'object') ? (req.body as Record<string, unknown>) : {};
    const id = typeof body['id'] === 'string' ? body['id'] : `mock-${Date.now()}`;
    const payload = {
        id,
        title: (body['title'] as string) || 'New record',
        status: (body['status'] as string) || 'draft',
        updated_at: new Date().toISOString(),
        ...body,
    };
    return mockSuccess(payload, 'Saved (mock)');
}

export function resolveMockApiResponse(req: HttpRequest<unknown>): ApiResponse<unknown> | null {
    if (!shouldMockRequest(req.url)) {
        return null;
    }
    for (const entry of MOCK_ROUTE_REGISTRY) {
        if (entry.method && entry.method !== req.method) {
            continue;
        }
        if (!entry.pattern.test(req.url)) {
            continue;
        }
        const result = entry.handler({ method: req.method, url: req.url, body: req.body });
        if (result === null) {
            return null;
        }
        return result as ApiResponse<unknown>;
    }
    if (isUiOnlyPhase() && ['POST', 'PUT', 'PATCH'].includes(req.method)) {
        return genericWriteSuccess(req);
    }
    return {
        id: 'mock-not-found',
        status: 'error',
        title: 'Mock not found',
        message: `No mock for ${req.method} ${req.url}`,
        httpCode: 404,
        code: 'MOCK_NOT_FOUND',
        errors: null,
        payload: null,
    };
}
